export default __webpack_public_path__ + "static/media/8.0cf61500.jpg";